// extracted by mini-css-extract-plugin
export var filterIncDec = "_3k-0";
export var leftBorder = "_3k-1";
export var rightBorder = "_3k-2";
export var stringInput = "_3k-3";